import React from 'react'
import { NumericFormat } from 'react-number-format'

import { formatCentsToDollars } from 'utils/price'

import type { NumericFormatProps } from 'react-number-format'

type Props = Omit<NumericFormatProps, 'value'> & {
  value?: string | number | null
  formatToDollars?: boolean
}

const HHDisplayMoney: React.FC<Props> = ({ value = '', formatToDollars = true, ...rest }) => (
  <NumericFormat
    value={formatToDollars ? formatCentsToDollars(value) : value ?? ''}
    displayType="text"
    thousandSeparator
    decimalSeparator="."
    decimalScale={2}
    fixedDecimalScale
    prefix="$"
    {...rest}
  />
)

export default HHDisplayMoney
